namespace $.$$ {

	export class $rise_devtools_selector_overlay extends $.$rise_devtools_selector_overlay {

		visible() {
			return this.active() && Boolean( this.rect() )
		}

		content() {
			if( !this.visible() ) return []
			return [ this.Panel() ]
		}

		panel_content() {
			return [
				this.Label(),
				... this.selected() ? [ this.Files() ] : [],
			] as readonly $mol_view[]
		}

		target_title() {
			return this.target_id() || this.target_name() || 'unknown'
		}

		display() {
			return this.visible() ? 'block' : 'none'
		}

		left_px() {
			return `${ this.rect()?.left ?? 0 }px`
		}

		top_px() {
			return `${ this.rect()?.top ?? 0 }px`
		}

		width_px() {
			return `${ this.rect()?.width ?? 0 }px`
		}

		height_px() {
			return `${ this.rect()?.height ?? 0 }px`
		}

		panel_open_down() {
			const rect = this.rect()
			if( !rect ) return true

			const space_above = rect.top
			const space_below = this.$.$mol_dom_context.innerHeight - rect.bottom

			return space_below >= space_above
		}

		panel_top() {
			return this.panel_open_down() ? '100%' : 'auto'
		}

		panel_bottom() {
			return this.panel_open_down() ? 'auto' : '100%'
		}

		panel_max_width() {
			const rect = this.rect()
			const left = rect?.left ?? 0
			const width = this.$.$mol_dom_context.innerWidth - left - 8

			return `${ Math.max( 0, Math.floor( width ) ) }px`
		}

		panel_max_height() {
			const rect = this.rect()
			if( !rect ) return 'none'

			const space = this.panel_open_down()
				? this.$.$mol_dom_context.innerHeight - rect.bottom
				: rect.top

			return `${ Math.max( 0, Math.floor( space - 8 ) ) }px`
		}

		pointer_events() {
			return this.selected() ? 'auto' : 'none'
		}

	}

}
